import React, { useEffect, useState } from "react";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import PageLoader from "../components/PageLoader";

const AcceptOffer = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [message, setMessage] = useState("");
  const location = useLocation();
  const navigate = useNavigate();

  const getDataFromlocalStorage = (key) => {
    try {
      const serializedData = localStorage.getItem(key);
      return serializedData ? JSON.parse(serializedData) : null;
    } catch (error) {
      console.error("Error getting data from localStorage:", error);
      return null;
    }
  };

  useEffect(() => {
    const storedUserPreferences = getDataFromlocalStorage("userData");
    if (!storedUserPreferences) {
      navigate("/login", { state: { from: location.pathname + location.search } });
      return;
    }
    
    if (storedUserPreferences.role === "dealer") {
      setError("This offer link is for private buyers. Redirecting to your dealer dashboard...");
      setLoading(false);
      setTimeout(() => {
        navigate("/dealer/dashboard");
      }, 3000);
      return;
    }

    const source = axios.CancelToken.source();
    const searchParams = new URLSearchParams(location.search);
    const slug = searchParams.get("on");

    if (!slug) {
      setError("Request id is missing in the URL.");
      setLoading(false);
      return;
    }

    // API call to update car status
    axios
      .post(`${window.CARLOCA_API}/status/bidding-buyer`, {
        status: "accept-by-buyer",
        unid: slug,
      }, { cancelToken: source.token })
      .then((response) => {
        if (response?.data?.status) {
          setMessage(response?.data?.message || "Request processed successfully.");
          setLoading(false);
        } else {
          setError(response?.data?.message || "Request failed.");
          setLoading(false);

        }
      })
      .catch((err) => {
        if (axios.isCancel(err)) {
          // console.log("Request canceled:", err.message);
        } else {
          setError(err.response?.data?.message || "Failed to update car status.");
          setLoading(false);
        }
      });
    return () => {
      source.cancel("Operation canceled by the user."); // Cancel the request on component unmount
    };
  }, [location.search]);

  if (loading) {
    return <PageLoader text="Processing your offer..." />;
  }

  if (error) {
    return (
      <div className="cl-auth-page">
        <div className="cl-auth-card" style={{ maxWidth: 480 }}>
          <div className="text-center">
            <div className="cl-empty-icon" style={{ background: "#fde8e8" }}><i className="fa-solid fa-circle-exclamation" style={{ color: "#ef4444" }}></i></div>
            <h5 className="cl-empty-title mt-3">Something Went Wrong</h5>
            <p className="cl-empty-text">{error}</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="cl-auth-page">
      <div className="cl-auth-card" style={{ maxWidth: 480, textAlign: "center" }}>
        <div className="cl-empty-icon" style={{ background: "#d1fae5" }}><i className="fa-solid fa-circle-check" style={{ color: "#10b981" }}></i></div>
        <h5 className="cl-page-title mt-3">Thank You!</h5>
        <p className="cl-page-subtitle">We appreciate your continued interest in this car.</p>
        <p style={{ color: "#374151", fontSize: "1rem" }}>{message}</p>
        <p className="cl-page-subtitle" style={{ fontSize: 14, marginTop: 16 }}>Your dream car is closer than you think!</p>
        <button className="cl-btn cl-btn-primary cl-btn-lg w-100 mt-3" onClick={() => window.open(window.CARLOCA_WEB + "/#/unlockedcars", "_blank")}>
          View Unlocked Car
        </button>
      </div>
    </div>
  );
};

export default AcceptOffer;
